// 214 §3 [RULED 52] — « SUSPENDRE » ASKS THE DATE, today by default. One small window for a counsel's link and for
// a client's own counsel's (a contact with the role Avocat): the person's name in the title, one date field, the
// two buttons. It writes nothing itself — the caller's `onConfirm(date)` goes to the link's own status route (a
// regular case) or into the element (a collective case). Its own file because it holds the typed date.
/* `import React`: react/react-in-jsx-scope is counted per JSX element and this is the rule's own remedy (189 §E). */
import React, { useState } from "react";
import { ModalLayout } from "./SharedUI";
import { FS } from "../lib/tokens";
import { todayIso } from "../lib/counselLinks";
import type { TFn } from "../lib/taxonomyTypes";

interface Props {
  readonly name: string;
  readonly t: TFn;
  readonly onConfirm: React.Dispatch<string>;
  readonly onClose: () => void;
}

export default function LinkSuspendDialog({ name, t, onConfirm, onClose }: Props) {
  const [date, setDate] = useState(todayIso());
  const valid = /^\d{4}-\d{2}-\d{2}$/.test(date);
  return (
    <ModalLayout
      title={t("link.suspend.title", { name, fallback: `Suspend ${name}` })}
      onClose={onClose}
      closeOnOverlay
      maxWidth={420}
      rawBody
      footer={
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", padding: "10px 20px", borderTop: "1px solid var(--br)" }}>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            {t("common.cancel", { fallback: "Cancel" })}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            data-link-suspend-confirm=""
            disabled={!valid}
            onClick={() => {
              if (valid) onConfirm(date);
            }}
          >
            {t("co.action.suspend", { fallback: "Suspend" })}
          </button>
        </div>
      }
    >
      <div style={{ padding: "14px 20px" }} data-link-suspend="">
        <p style={{ fontSize: FS.s11_5, color: "var(--ts)", margin: "0 0 10px", lineHeight: 1.5 }}>
          {t("link.suspend.body", { fallback: "The person stays on the matter, apart from the acting ones and dated; their e-mails are still found here; new documents no longer print them." })}
        </p>
        <div className="field">
          <label>{t("link.suspend.since", { fallback: "Since" })}</label>
          <input
            className="field-input"
            type="date"
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
        </div>
      </div>
    </ModalLayout>
  );
}
